import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full p-2" }
const _hoisted_2 = { class: "m-0 overflow-hidden text-overflow-ellipsis white-space-nowrap" }

import { Post } from '@/models/post';


export default /*#__PURE__*/_defineComponent({
  props: {
    post: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_ctx.$router.push(`/post/${__props.post.uuid}`);}, ["stop"])),
        class: "cursor-hover"
      }, _toDisplayString(__props.post.title ? __props.post.title : __props.post.url), 1)
    ])
  ]))
}
}

})